import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import type { VehicleId } from '../../types/gcs/vehicle';
import type { MissionId } from '../../types/gcs/mission';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';
import { getShortVehicleId } from '../../utils/formatters';

interface ConfirmSafeUpDialogProps {
  gcsId: string;
  vehicleId: VehicleId;
  missionId: MissionId;
  onClose: () => void;
}

function ConfirmSafeUpDialog({ gcsId, vehicleId, missionId, onClose }: ConfirmSafeUpDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [safeUpAction, setSafeUpAction] = useState<AsyncAction>(AsyncAction.initial());
  const safeUp = useGcsStore((state) => state.safeUp);
  const vehicleLabel = getShortVehicleId(vehicleId);

  const onConfirmClicked = async () => {
    try {
      setSafeUpAction(AsyncAction.loading());
      await safeUp(gcsId, missionId);
      setSafeUpAction(AsyncAction.success(undefined));
      onClose();
    } catch (error) {
      setSafeUpAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmSafeUpLandDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmSafeUpLandDialog.safeUpButton,
        callback: onConfirmClicked,
        isLoading: safeUpAction.isLoading,
        backgroundColor: 'var(--color-danger)',
        foregroundColor: '#ffffff'
      }}
      errorText={safeUpAction.isFailure ? getLocalizedErrorMessage(safeUpAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmSafeUpLandDialog.body.replace('{vehicle}', vehicleLabel)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmSafeUpDialog;
